"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getGroupDatas = getGroupDatas;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _controlled = require("../Form/controlled");
var _excluded = ["className", "value", "onChange", "groups", "options", "placeholder", "type", "disabled", "style", "size", "mSize", "width"];
function getGroupDatas(options) {
  var data = {};
  options.map(function (item) {
    var groupKey = item.groupKey;
    if (groupKey && !data[groupKey]) {
      data[groupKey] = [];
    }
    if (groupKey && data[groupKey]) {
      data[groupKey].push(item);
    }
    return null;
  });
  return data;
}
var NativeSelect = function NativeSelect(props) {
  var _classnames;
  var _useDefaultValue = (0, _controlled.useDefaultValue)(props, ''),
    className = _useDefaultValue.className,
    value = _useDefaultValue.value,
    onChange = _useDefaultValue.onChange,
    _useDefaultValue$grou = _useDefaultValue.groups,
    groups = _useDefaultValue$grou === void 0 ? {} : _useDefaultValue$grou,
    _useDefaultValue$opti = _useDefaultValue.options,
    options = _useDefaultValue$opti === void 0 ? [] : _useDefaultValue$opti,
    _useDefaultValue$plac = _useDefaultValue.placeholder,
    placeholder = _useDefaultValue$plac === void 0 ? '请选择' : _useDefaultValue$plac,
    type = _useDefaultValue.type,
    disabled = _useDefaultValue.disabled,
    style = _useDefaultValue.style,
    size = _useDefaultValue.size,
    mSize = _useDefaultValue.mSize,
    width = _useDefaultValue.width,
    extraProps = (0, _objectWithoutProperties2.default)(_useDefaultValue, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('select');
  var classes = (0, _classnames2.default)(prefixCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(prefixCls, "--").concat(type), !!type), (0, _defineProperty2.default)(_classnames, "size-".concat(size), size && size !== 'default'), (0, _defineProperty2.default)(_classnames, "m-size-".concat(mSize), mSize && mSize !== 'default'), (0, _defineProperty2.default)(_classnames, "size-".concat(width, "-width"), width && width !== 'default'), _classnames));
  var handleClick = function handleClick(values, e) {
    if (onChange) {
      onChange(values, e);
    }
  };
  var renderGroup = function renderGroup() {
    var groupDatas = getGroupDatas(options);
    return Object.keys(groupDatas).map(function (key, index) {
      return /*#__PURE__*/_react.default.createElement("optgroup", {
        label: groups[key],
        key: key
      }, index === 0 && typeof placeholder === 'string' && /*#__PURE__*/_react.default.createElement("option", {
        disabled: !!value,
        hidden: true
      }, placeholder), groupDatas[key].map(function (item) {
        return /*#__PURE__*/_react.default.createElement("option", {
          value: item.value,
          key: item.value,
          disabled: item.disabled,
          title: typeof item.tooltip === 'string' ? item.tooltip : undefined
        }, typeof item.text === 'undefined' ? item.value : item.text);
      }));
    });
  };
  var renderOptions = function renderOptions() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, typeof placeholder === 'string' && /*#__PURE__*/_react.default.createElement("option", {
      disabled: !!value,
      hidden: true
    }, placeholder), options.map(function (item) {
      return /*#__PURE__*/_react.default.createElement("option", {
        value: item.value,
        key: item.value,
        disabled: item.disabled,
        title: typeof item.tooltip === 'string' ? item.tooltip : undefined
      }, typeof item.text === 'undefined' ? item.value : item.text);
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    defaultValue: value != null ? value : ''
  }), /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
    className: classes,
    value: value != null ? value : '',
    placeholder: placeholder,
    disabled: disabled,
    style: style,
    onChange: disabled ? undefined : function (event) {
      return handleClick(event.target.value, {
        event: event
      });
    }
  }, extraProps), options.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, options.find(function (opt) {
    return !!opt.groupKey;
  }) ? renderGroup() : renderOptions())));
};

// 组件的默认值
NativeSelect.defaultProps = {
  className: ''
};
var _default = exports.default = NativeSelect;